// When a highlight hops around a ring of faces and stops on one. The hops
// start fast and slow down, like a wheel that runs out of speed.

export type Hop = {
  /** The face the highlight is on. */
  index: number;
  /** When it gets there, counted from the start. */
  atMs: number;
};

/**
 * `hops` stops in ring order that end on `target` at `totalMs`. The gap before
 * the last stop is `slowdown` times the gap after the first.
 */
export const hopSchedule = (
  target: number,
  faceCount: number,
  hops: number,
  totalMs: number,
  slowdown: number,
): Hop[] => {
  if (faceCount <= 0 || hops <= 0) return [];
  const gapCount = hops - 1;
  const gaps = Array.from({ length: gapCount }, (_, gap) =>
    gapCount === 1 ? 1 : 1 + ((slowdown - 1) * gap) / (gapCount - 1),
  );
  const gapTotal = gaps.reduce((sum, gap) => sum + gap, 0);
  let elapsed = 0;
  return Array.from({ length: hops }, (_, hop) => {
    if (hop > 0) elapsed += gaps[hop - 1] ?? 0;
    const stepsFromTarget = gapCount - hop;
    const index = (((target - stepsFromTarget) % faceCount) + faceCount) % faceCount;
    return { index, atMs: gapTotal === 0 ? 0 : Math.round((elapsed / gapTotal) * totalMs) };
  });
};
